import { MemoTable } from "../../../components/MemoTable";
import { PeriodSelector } from "../../../components/PeriodSelector";
import { MetricsType } from "../../../metrics.types";
import {
    incomeStatementResolutionAtom,
    incomeStatementMetricsAtom,
} from "../../../metrics.state";
import { useCallback } from "react";
import { useAtomValue, useAtom } from "jotai";
import { AIMContextViewAtom } from "../../../state/context.state";
import { AIMViewType } from "../../../InvestmentMemo.types";
import {
    isLoadingAtom,
    ISSummaryColumnAtom,
    ISSummaryDataAtom,
} from "./ISSummary.state";
import { CellClickedEvent } from "ag-grid-enterprise";
import { SummaryRow } from "../SummaryFinancials.types";
import { defaultColDef } from "../defaultColDef";
import clsx from "clsx";

export function IncomeStatementSummary() {
    const metrics = useAtomValue(incomeStatementMetricsAtom);
    const resolution = useAtomValue(incomeStatementResolutionAtom);
    const data = useAtomValue(ISSummaryDataAtom);
    console.log("income statement table", metrics, data);
    const columns = useAtomValue(ISSummaryColumnAtom);
    const [getAIMContextView, setAIMContextView] = useAtom(AIMContextViewAtom);
    const isLoading = useAtomValue(isLoadingAtom);
    const selectedCell = (getAIMContextView as any)?.selectedCell;
    const gridId = "summary-income-statement-grid";
    const handleClick = useCallback(
        (params: CellClickedEvent<SummaryRow>) => {
            const field = params.colDef.field;
            if (field === "label" || !params.data?.metric || !field) return;

            if (field === "popChange" && params.data.popChange) {
                setAIMContextView({
                    type: AIMViewType.DELTA_LINEAGE,
                    props: {
                        metric: params.data.metric,
                        metricLabel: params.data.label,
                        currentSlice: params.data.currentSlice,
                        previousSlice: params.data.previousSlice,
                        popChange: params.data.popChange,
                        fieldType: params.data.fieldType,
                        resolutionWindow: resolution.window || "",
                        popLabel: params.colDef.headerName,
                    },
                    selectedCell: {
                        rowId: params.node?.id ?? "",
                        colField: field,
                        gridId,
                    },
                });
                return;
            } else {
                setAIMContextView({
                    type: AIMViewType.VALUE_LINEAGE,
                    metric: params.data.metric,
                    period: field === "popChange" ? "% Change" : field,
                    title: params.data.label,
                    isExpanded: field === "popChange" ? false : true,
                    selectedCell: {
                        rowId: params.node?.id ?? "",
                        colField: field,
                        gridId,
                    },
                });
            }
        },
        [metrics, resolution, setAIMContextView],
    );

    return (
        <div id="summary-income-statement" className="space-y-3">
            <div className="flex items-center justify-between">
                <h4 className="heading-m">Summary Income Statement</h4>
                <PeriodSelector
                    resolutionAtom={incomeStatementResolutionAtom}
                    metricsType={MetricsType.INCOME_STATEMENT}
                />
            </div>
            {isLoading ? (
                <div
                    className={clsx(
                        "h-[377px] w-full animate-pulse rounded-lg bg-slate-600",
                    )}
                />
            ) : (
                <MemoTable
                    data={data}
                    columns={columns}
                    onCellClicked={handleClick}
                    defaultColDef={defaultColDef(
                        (getAIMContextView as any)?.selectedCell,
                    )}
                    gridId={
                        gridId +
                        "-" +
                        selectedCell?.rowId +
                        "-" +
                        selectedCell?.colField
                    }
                />
            )}
        </div>
    );
}
